import CurrencyFlag from './currency-flag.vue';

export default CurrencyFlag;
